<script setup lang="ts">
import { AddressClient } from '@/api/modules/addresses/addresses.types'
import { DeliveryMethods } from '@/api/modules/basket/types'
import { BasketPoint } from '@/types/api/api-v3/basket-points'

import BasketAddressesCourier from '@/components/Basket/basket-addresses/BasketAddressesCourier.vue'
import BasketAddressesHall from '@/components/Basket/basket-addresses/BasketAddressesHall.vue'
import BasketAddressesPickup from '@/components/Basket/basket-addresses/BasketAddressesPickup.vue'

type Props = {
  deliveryMethod: DeliveryMethods
  selectedAddress?: BasketPoint | AddressClient
}
defineProps<Props>()

const emit = defineEmits(['delivery-method-changed', 'select-delivery-courier'])

const onDeliveryMethodChanged = () => {
  emit('delivery-method-changed')
}

const onSelectDeliveryCourier = () => {
  emit('select-delivery-courier')
}
</script>

<template>
  <div class="address-windows">
    <the-transition-height>
      <basket-addresses-courier
        v-if="deliveryMethod === DeliveryMethods.COURIER"
        :selected-address="selectedAddress as (AddressClient | undefined)"
        @delivery-method-changed="onDeliveryMethodChanged"
        @select-delivery-courier="onSelectDeliveryCourier"
      />

      <basket-addresses-pickup
        v-else-if="deliveryMethod === DeliveryMethods.PICKUP"
        :selected-address="selectedAddress as (BasketPoint | undefined)"
        @delivery-method-changed="onDeliveryMethodChanged"
        @select-delivery-courier="onSelectDeliveryCourier"
      />

      <basket-addresses-hall
        v-else-if="deliveryMethod === DeliveryMethods.HALL"
        :selected-address="selectedAddress as (BasketPoint | undefined)"
        @delivery-method-changed="onDeliveryMethodChanged"
        @select-delivery-courier="onSelectDeliveryCourier"
      />
    </the-transition-height>
  </div>
</template>

<style scoped lang="scss">
.addresses-windows {
  min-height: 110px;
}
</style>
